import { defineStore } from 'pinia'
import { useSessionStorage } from '@vueuse/core'
import { UserDetailsDto } from '@/components/models/userDetails'

const USER_STORE = 'userState'
export const useUserStore = defineStore('userStore', {
  state: () => {
    const storedUser = useSessionStorage(USER_STORE, null as string | null)
    const parsedUser = storedUser.value
      ? UserDetailsDto.fromJson(JSON.parse(storedUser.value))
      : null
    return {
      user: parsedUser
    }
  },

  actions: {
    setUser(user: UserDetailsDto) {
      const jsonString = JSON.stringify(user)
      this.user = user
      useSessionStorage(USER_STORE, jsonString)
    },

    clearUser() {
      this.user = null
      this.updateLocalStorage()
    },
    updateLocalStorage() {
      useSessionStorage(USER_STORE, this.user)
    }
  },

  getters: {
    isNewUser: (state) => state.user?.isNewUser() ?? false,
    userEmail: (state) => state.user?.email ?? '',
    hasData: (state) => state.user !== null,
    hasOperatorRights: (state) => {
      if (state.user === null) return false;
      if (!state.user.permissions) return false;
      if (!state.user.permissions.portOperatorRights) return false;
      return true;
    }
  }
})
